import { SpinnerService } from '@cpd-app/core-module/services';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '..';
import * as LoaderActions from './loader.actions';

@Injectable({ providedIn: 'root' })
export class LoaderFacade {
  constructor(
    private store: Store<AppState>,
    private spinnerService: SpinnerService
  ) {}

  public showLoaderUntil(actionType: string) {
    this.spinnerService.showSpinner();
    this.store.dispatch(LoaderActions.showLoaderUntil({ actionType }));
  }

  public hideLoader() {
    this.spinnerService.hideSpinner();
    this.store.dispatch(LoaderActions.resetState());
  }
}
